/* eslint-disable @atlassian/relay/unused-fields */
import { graphql, type GraphQLTaggedNode, type PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import type { rovoDevEntitlementResourceQuery } from './__generated__/rovoDevEntitlementResourceQuery.graphql';

const QUERY: GraphQLTaggedNode = graphql`
	query rovoDevEntitlementResourceQuery($cloudId: ID!) {
		devai_rovodevIssueViewQuery(cloudId: $cloudId) @optIn(to: "DevAiRovoDevIssueView") {
			checks {
				entitlementType
				userHasProductAccess
			}
			isFeatureEnabled
		}
	}
`;

const RESOURCE_TYPE_ROVO_DEV_ENTITLEMENT = 'ROVO_DEV_ENTITLEMENT';

export const rovoDevEntitlementResource: RouteResource<
	PreloadedQuery<rovoDevEntitlementResourceQuery, Record<string, unknown>>
> = createRelayResource<rovoDevEntitlementResourceQuery>({
	type: RESOURCE_TYPE_ROVO_DEV_ENTITLEMENT,
	getQuery: (_, { tenantContext }) => {
		const cloudId = tenantContext?.cloudId ?? '';

		if (!cloudId || tenantContext?.isAnonymous) {
			return {
				parameters: QUERY,
				variables: { cloudId: '' },
				options: { fetchPolicy: 'store-only' },
			};
		}

		return {
			parameters: QUERY,
			variables: { cloudId },
			options: { fetchPolicy: 'store-or-network' },
		};
	},
	isBrowserOnly: false, // SSR for issue view
});
